// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  body * {
    visibility: hidden;
    max-width: 1048px;
  }

  #print-template-preview, #print-template-preview * {
    visibility: visible;
  }

  #print-template-preview {
    height: 100%;
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TemplatesListPage/RequirementsTemplates/panels/TemplateListPanel/TemplatePreviewTray/styles.css"],"names":[],"mappings":"AAAA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,MAAM;EACR;AACF","sourcesContent":["@media print {\n  body * {\n    visibility: hidden;\n    max-width: 1048px;\n  }\n\n  #print-template-preview, #print-template-preview * {\n    visibility: visible;\n  }\n\n  #print-template-preview {\n    height: 100%;\n    position: absolute;\n    width: 100%;\n    left: 0;\n    top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
